import React from 'react';
import { CustomStepProps } from '../../types/survey';
import { Button } from '../ui/Button';

/**
 * Simple intro screen for the survey
 */
export const SimpleIntroScreen: React.FC<CustomStepProps> = ({ 
  onNext
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">

        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Welcome to Lifestyle Questionnaire
            </h1>
            <p className="text-lg text-gray-600 mb-8">
            Every journey starts with the first step.
            In this case it is your self-evaluation questionnaire, which will help our experts to understand where you are and which path to take on your own journey to the most optimal health.
            </p>
            
            <div className="space-y-4 text-left max-w-md mx-auto mb-8">
              <div className="flex items-start">
                <span className="text-royal-gold mr-2">•</span>
                <span className="text-gray-700">Answer a few simple questions</span>
              </div>
              <div className="flex items-start">
                <span className="text-royal-gold mr-2">•</span>
                <span className="text-gray-700">Get personalized advice from our experts</span>
              </div>
              <div className="flex items-start">
                <span className="text-royal-gold mr-2">•</span>
                <span className="text-gray-700">Your progress is saved automatically</span>
              </div>
            </div>

            <Button
              onClick={onNext}
              variant="primary"
              size="lg"
              className="transform hover:-translate-y-0.5 transition-transform duration-200"
            >
              Start Survey
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};